import {gql} from "graphql-tag";
import {baseResponseGraphqlField} from "../../../base.graphql";


export const newsCategoryFields = `
id
uniqueId
name
description
`;


export const CREATE_NEWS_CATEGORY_MUTATION = gql`
mutation CreateNewsCategoryMutation($input: NewsCategoryInputObject!) {
  createNewsCategoryMutation(input: $input) {
    ${baseResponseGraphqlField}
    data {
      ${newsCategoryFields}
    }
  }
}
`


export const UPDATE_NEWS_CATEGORY_MUTATION = gql`
mutation UpdateNewsCategoryMutation($input: NewsCategoryInputObject!) {
  updateNewsCategoryMutation(input: $input) {
    ${baseResponseGraphqlField}
    data {
      ${newsCategoryFields}
    }
  }
}
`


export const DELETE_NEWS_CATEGORY_MUTATION = gql`
mutation DeleteNewsCategoryMutation($uniqueId: String!) {
  deleteNewsCategoryMutation(uniqueId: $uniqueId) {
    ${baseResponseGraphqlField}
  }
}
`


export const GET_NEWS_CATEGORIES = gql`
query GetNewsCategories($filtering: NewsCategoryFilteringInputObject) {
  getNewsCategories(filtering: $filtering) {
    ${baseResponseGraphqlField}
    data {
      ${newsCategoryFields}
    }
  }
}
`
